var $ = require("jquery");
var moment = require("moment");

function pad2(num) {
    return ("0" + num).slice(-2);
}

module.exports = function (element) {

    var $form = $(element);

    var $dateFrom = $form.find("#date-from");
    var $dateTo = $form.find("#date-to");
    var $roomCount = $form.find("#room-count");

    var diff = 1;

    $dateFrom.datepicker()
        .on("changeDate",
            function(e) {
                $dateTo.datepicker("setStartDate", moment(e.date).add(1, 'days').toDate());
                $dateTo.datepicker("setDate", moment(e.date).add(diff, 'days').toDate());
            });

    $dateTo.datepicker()
        .on("changeDate",
            function (e) {
                var dateFrom = moment($dateFrom.datepicker("getDate"));
                var dateTo = moment(e.date);

                diff = dateTo.diff(dateFrom, 'days');
            });

    $roomCount
        .on("change",
            function() {
                var count = parseInt($roomCount.val());

                for (var i = 1; i <= 8; i++) {
                    $form.find("#room-" + i).toggle(i <= count);
                    $form.find("[name=roomAge" + i + "]").prop("disabled", i > count);
                }
            });

    $form.on("submit", function (ev) {
        var dateFrom = moment($dateFrom.datepicker("getDate"));
        var dateTo = moment($dateTo.datepicker("getDate"));

        $form.find("[name=fday]").val(pad2(dateFrom.date()));
        $form.find("[name=fmonth]").val(pad2(dateFrom.month() + 1));
        $form.find("[name=fyear]").val(dateFrom.year());

        $form.find("[name=tday]").val(pad2(dateTo.date()));
        $form.find("[name=tmonth]").val(pad2(dateTo.month() + 1));
        $form.find("[name=tyear]").val(dateTo.year());

        for (var i = 1; i <= 8; i++) {

            var adults = parseInt($form.find("#adults-" + i).val());
            var children = parseInt($form.find("#children-" + i).val());

            var ages = [];
            for (var j = 0; j < adults; j++)
                ages.push(40);
            for (var j = 0; j < children; j++)
                ages.push(8);

            $form.find("[name=roomAge" + i + "]").val(ages.join(","));

        }

    });

};


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/controllers/reservit-form.js
// module id = 246
// module chunks = 0